type EducationKeys = 'creche' | 'pré-escola' | 'escola';

export const goals: Record<EducationKeys, number> = {
  'pré-escola': 50,
  creche: 100,
  escola: 95
};
